export const ELIVAAS_PROVIDER_CODE = 'elivaas';

export const extractElivaasProviderId = (itemOrValue = {}) => {
  if (typeof itemOrValue === 'string' || typeof itemOrValue === 'number') {
    const value = String(itemOrValue || '').trim();
    const match = value.match(/^provider:elivaas:(.+)$/i);
    return match ? match[1] : '';
  }

  const providerCode = String(
    itemOrValue.provider_code || itemOrValue.providerCode || itemOrValue.provider || ''
  )
    .trim()
    .toLowerCase();
  const hasExplicitProviderId = Boolean(
    itemOrValue.provider_property_id ||
      itemOrValue.providerPropertyId ||
      itemOrValue.provider_id ||
      itemOrValue.providerId
  );
  const rawId = String(
    itemOrValue.provider_property_id ||
      itemOrValue.providerPropertyId ||
      itemOrValue.provider_id ||
      itemOrValue.providerId ||
      itemOrValue.id ||
      ''
  ).trim();
  const providerMatch = rawId.match(/^provider:elivaas:(.+)$/i);

  if (providerMatch) return providerMatch[1];
  if (
    providerCode === ELIVAAS_PROVIDER_CODE ||
    itemOrValue.is_external === true ||
    itemOrValue.source === 'api' ||
    hasExplicitProviderId
  ) {
    return rawId;
  }
  return '';
};

export const isElivaasProviderItem = (itemOrValue = {}) => {
  if (typeof itemOrValue === 'string' || typeof itemOrValue === 'number') {
    return /^provider:elivaas:/i.test(String(itemOrValue || '').trim());
  }
  return Boolean(extractElivaasProviderId(itemOrValue));
};

export const buildElivaasDetailPath = (itemOrValue = {}, suffix = '') => {
  const providerId = extractElivaasProviderId(itemOrValue);
  return providerId ? `/stays/homevilas/${encodeURIComponent(providerId)}${suffix || ''}` : '';
};
